import config from '@/config';
import { useEventProvider } from '@/helpers/event-context';

export default function useLinksData() {
  const { getPageName } = useEventProvider();
  const registerUrl = config.auth.registerUrl;

  return [
    {
      title: 'Company',
      links: [
        {
          page: 'About',
          url: '/about',
        },
        {
          page: 'Contact Us',
          url: '/contact-us',
        },
      ],
    },
    {
      title: 'Resources',
      links: [
        {
          page: 'VuSocial Reviews',
          url: '/testimonial',
        },
        {
          page: 'Register',
          url: registerUrl + `?s=${getPageName()}`,
        },
      ],
    },
    {
      title: 'Legal',
      links: [
        {
          page: 'Privacy Policy',
          url: '/privacy-policy',
        },
        {
          page: 'Terms & Conditions',
          url: '/terms-of-service',
        },
      ],
    },
  ];
}
